import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=873da6b8&"
import script from "./SearchForm.vue?vue&type=script&lang=ts&"
export * from "./SearchForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports